var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconToastError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.5,40.4c2,1.9,2,5.1,0.1,7.1c-1.9,2-5.1,2-7.1,0.1l-9.8-9.5l-6.4-6.2L8.4,47.7c-2,1.9-5.2,1.8-7.1-0.2 c-1.9-2-1.8-5.2,0.2-7.1L18,25L1.6,9.7c-2-1.9-2.1-5.1-0.2-7.1c1.9-2,5.1-2.1,7.1-0.2l16.9,15.8L41.5,2.4c2-1.9,5.1-1.9,7.1,0.1 c1.9,2,1.9,5.1-0.1,7.1L32.5,25l6.1,5.9L48.5,40.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToastError);
export default __webpack_public_path__ + "static/media/icon-toast-error.f31828845b50ce89645b78fce891bf58.svg";
export { ForwardRef as ReactComponent };